import { TFunction } from 'i18next';
import { BackgroundJobStatusEnum } from 'graphql-common';
import { ChipTypes } from '@lib/components/Chip/Chip';

type Args = {
  status?: BackgroundJobStatusEnum | null;
  failed?: number | null;
  t: TFunction<'translation', undefined>;
};

// A terminal Complete node with failed units is a partial success, not a
// clean one — badge it "Completed with N errors" instead of a plain success
// chip (BE guide §9).
export default function getJobStatusChipProps({ status, failed, t }: Args): {
  label: string;
  type: ChipTypes;
} {
  if (status === BackgroundJobStatusEnum.Complete) {
    if (failed) {
      return {
        label: t('completed-with-errors', { count: failed }),
        type: ChipTypes.chipYellow,
      };
    }
    return { label: t('completed'), type: ChipTypes.chipGreen };
  }
  if (status === BackgroundJobStatusEnum.Failed) {
    return { label: t('failed'), type: ChipTypes.chipRed };
  }
  if (status === BackgroundJobStatusEnum.Working) {
    return { label: t('in-progress'), type: ChipTypes.chipBlue };
  }
  if (status === BackgroundJobStatusEnum.Retrying) {
    return { label: t('retrying'), type: ChipTypes.chipYellow };
  }
  if (status === BackgroundJobStatusEnum.Interrupted) {
    return { label: t('interrupted'), type: ChipTypes.chipCorral };
  }
  if (status === BackgroundJobStatusEnum.Stopped) {
    return { label: t('stopped'), type: ChipTypes.chipBlack };
  }
  return { label: t('queued'), type: ChipTypes.chipViolet };
}
